// extracted by mini-css-extract-plugin
export default {"modal":"LP-z","error":"MP-z","disabled":"NP-z","fields":"OP-z","errorMsg":"PP-z","footer":"QP-z","formContentWrapper":"RP-z","productImage":"SP-z","overlay":"TP-z"};